import * as jsxRuntime from "/root/workspace/cms-vite-wechat_YHsD/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment